import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {PageHtml5Service} from './page-html-5.service';
import {IPageHtml5, PageHtml5} from './page-html-5.model';
import {KeyValue} from '../landing-page/transactional-email.model';

@Component({
    selector: 'select-page-html-5',
    templateUrl: './select-page-html-5.component.html',
    standalone: false
})
export class SelectPageHtml5Component implements OnInit {
    items: KeyValue[] = [];
    item: KeyValue;

    @Input() value: string;
    @Output() valueChange = new EventEmitter<string>();

    constructor(
        protected pageHtml5Service: PageHtml5Service
    ) {

    }

    loadAll() {
        this.pageHtml5Service.list().subscribe(list => {
            this.items = list;
            if (this.value == null) {
                this.items.unshift({key: null, value: 'Sélectionner une valeur'});
            }
            if (this.value) {
                for (let i = 0; i < list.length; i++) {
                    const item = list[i];
                    if (item.key == String(this.value)) {
                        this.item = item;
                        break;
                    }
                }
            }
        });
    }


    ngOnInit() {
        this.loadAll();
    }


    new() {
        let name = prompt('Nom de la nouvelle page HTML5 :');
        if (name != null) {
            let pageHtml: IPageHtml5 = {
                ...new PageHtml5(),
                code: this.pageHtml5Service.buildCode(name),
                name: name
            };
            this.pageHtml5Service.create(pageHtml).subscribe(data => {
                this.value = data.body.code;
                this.loadAll();
                this.valueChange.emit(this.value);
            });
        }
    }

    change(event: Event) {
        this.valueChange.emit(this.item.key);
    }

}
